<template>
	<div class="placeholder-panel">
		<div class="placeholder-panel-copy">
			<header>
				<h1><slot name="title"></slot></h1>
			</header>
			<main>
				<slot name="body"></slot>
			</main>
		</div>
		<footer>
			<slot name="footer"></slot>
		</footer>
	</div>
</template>

<script>
export default {
	name: "PlaceholderPanel",
};
</script>

<style lang="scss" scoped>
$placeholderPanelTextColor: $color1-500;
$placeholderPanelCopyBackgroundColor: $color1-050;

.placeholder-panel {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	//padding: 1.5rem;

	h1 {
		@include font-and-line-for(2);
		color: $placeholderPanelTextColor;
		font-weight: 600;
	}

	main {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 1rem;
	}

	footer {
		display: flex;
		flex-direction: row;
	}

	@include for-size('md') {
		footer {
			margin-top: 1rem;
		}
	}
}

.placeholder-panel-copy {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 1rem;

	background-color: $placeholderPanelCopyBackgroundColor;
	border-radius: 0.5rem;

	padding: 1.5rem;
}
</style>

<style lang="scss">
$placeholderPanelTextColor: $color1-500;

.placeholder-panel {
	text-align: left;

	p {
		@include font-and-line-for(1);
		color: $placeholderPanelTextColor;
	}
}
</style>
